// React Query cache keys
export const USER_PROFILE_QUERY_KEY = 'userProfile';
export const ORGANISATIONS_QUERY_KEY = 'organisations';
export const FARMS_QUERY_KEY = 'farms';
export const ZONES_QUERY_KEY = 'zones';
export const ZONE_BY_ID_QUERY_KEY = 'zoneById';
export const INPUTS_QUERY_KEY = 'inputs';
export const INPUT_BY_ID_QUERY_KEY = 'inputById';

export const G_BIOSTIMULANT_QUERY_KEY = 'gBiostimulant';
export const M_BIOSTIMULANT_QUERY_KEY = 'mBiostimulant';
export const M_SEARCH_BIOSTIMULANT_QUERY_KEY = 'mSearchBiostimulant';

export const G_CROPS_QUERY_KEY = 'gCrops';
export const M_CROPS_QUERY_KEY = 'mCrops';
export const M_SEARCH_CROPS_QUERY_KEY = 'mSearchCrops';
export const G_CROP_BY_ID_QUERY_KEY = 'gCropById';

export const G_CONSTRAINT_QUERY_KEY = 'gConstraint';
export const M_CONSTRAINT_QUERY_KEY = 'mConstraint';
export const M_SEARCH_CONSTRAINT_QUERY_KEY = 'mSearchConstraint';

export const G_OPERATION_QUERY_KEY = 'gOperation';
export const M_OPERATION_QUERY_KEY = 'mOperation';
export const M_SEARCH_OPERATION_QUERY_KEY = 'mSearchOperation';

// Plant Protection (Chemical) and Adjuvant tabs browse separate
// useWater-scoped routes and search independently, so each has its own keys.
export const G_CHEMICAL_QUERY_KEY = 'gChemical';
export const M_CHEMICAL_QUERY_KEY = 'mChemical';
export const M_SEARCH_CHEMICAL_QUERY_KEY = 'mSearchChemical';
export const G_ADJUVANT_QUERY_KEY = 'gAdjuvant';
export const M_ADJUVANT_QUERY_KEY = 'mAdjuvant';
export const M_SEARCH_ADJUVANT_QUERY_KEY = 'mSearchAdjuvant';

export const G_SOILINPUT_QUERY_KEY = 'gSoilInput';
export const M_SOILINPUT_QUERY_KEY = 'mSoilInput';
export const M_SEARCH_SOILINPUT_QUERY_KEY = 'mSearchSoilInput';

export const G_TIMING_QUERY_KEY = 'gTiming';
export const M_TIMING_QUERY_KEY = 'mTiming';
export const M_SEARCH_TIMING_QUERY_KEY = 'mSearchTiming';

export const G_UNITS_QUERY_KEY = 'gUnits';
export const G_AREA_UNITS_QUERY_KEY = 'gAreaUnits';
export const G_PARAMETERS_QUERY_KEY = 'gParameters';
